import { ActionType, getType } from 'typesafe-actions';

import * as currentOrder from '../../actionCreators/currentOrder';

const initialState = null;

export default function (
  state: Surcharge[] | null = initialState,
  action: ActionType<typeof currentOrder>,
): Surcharge[] | null {
  switch (action.type) {
    case getType(currentOrder.setDeliverySurcharges): {
      const { value } = action.payload;
      return value || initialState;
    }
    case getType(currentOrder.applyBufferData): {
      const { deliverySurcharges } = action.payload.value;
      return deliverySurcharges === undefined ? state : deliverySurcharges;
    }
    default:
      return state;
  }
}
